// removed by extract-text-webpack-plugin
module.exports = {"main":"_2sg_EDSS5mGyI1mjHDSXqW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/main/main.scss
// module id = 452
// module chunks = 0